import {ReactElement} from "react";
import {Cell, HeaderCell} from "@zendeskgarden/react-tables";
import * as css from "../../summary/revenueSummary.module.scss";
import {AffordableRevenueSummaryItemModel} from "../../../../../__generated__/generated_types";
import cn from "classnames";
import tableCSS from "../../../../property-executive-summary/styles/table.module.scss";

export function buildAffordableNumbers(item: AffordableRevenueSummaryItemModel): number[] {
    return [...item.reforecast, ...item.budget];
}

export function buildAffordableCells(
    reforecastStartMonthIndex: number,
    reforecastNumbers: number[],
    budgetNumbers: number[],
    formatter: Intl.NumberFormat,
): ReactElement[] {
    reforecastNumbers = reforecastNumbers.slice(reforecastStartMonthIndex, 12);

    const cells: ReactElement[] = [];

    reforecastNumbers.forEach((val, index) => {
        cells.push(
            <Cell key={`rfcst-${index}`}>
                {formatter.format(val)}
            </Cell>
        );
    });

    budgetNumbers.forEach((val, index) => {
        cells.push(
            <Cell key={`bdgt-${index}`} className={index === 0 ? css.periodSplit : undefined}>
                {formatter.format(val)}
            </Cell>
        );
    });

    return cells;
}

export function buildAffordableHeaderCells(
    reforecastStartMonthIndex: number,
    budgetYear: number,
    months: string[],
): ReactElement[] {
    const reforecastLabelYear = reforecastStartMonthIndex === 0 ? budgetYear - 1 : undefined;

    const reforecastHeaders = new Array(12 - reforecastStartMonthIndex).fill(null).map((_, index) => (
        <HeaderCell key={`rfcst-${index}`}>
            <div className={css.headerCellContent}>
                <span>RFCST</span>
                <span>{reforecastLabelYear !== undefined && index === 0 ? reforecastLabelYear.toString().slice(2) : ""}</span>
                <span>{months[index + reforecastStartMonthIndex]}</span>
            </div>
        </HeaderCell>
    ));

    const budgetHeaders = new Array(12).fill(null).map((_, index) => (
        <HeaderCell key={`bdgt-${index}`}>
            <div className={css.headerCellContent}>
                <span>BDGT</span>
                <span>{index === 0 ? budgetYear.toString().slice(2) : ""}</span>
                <span>{months[index]}</span>
            </div>
        </HeaderCell>
    ));

    return [
        <HeaderCell key="desc" className={cn(tableCSS.fixedCol, tableCSS.firstCol)}>Description</HeaderCell>,
        ...reforecastHeaders,
        ...budgetHeaders,
    ];
}
